// extracted by mini-css-extract-plugin
module.exports = {"loader-icon":"LoaderIcon_loader-icon__9xvuN","loader-icon--a-spin":"LoaderIcon_loader-icon--a-spin__28nrB","spin":"LoaderIcon_spin__3kmOt"};